import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      <div className="container py-6">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Logo */}
          <Link
            to="/"
            className="flex items-center gap-2"
            aria-label="모아PC 홈으로 이동"
          >
            <div className="w-8 h-8 bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-lg">M</span>
            </div>
            <span className="text-lg font-bold text-gray-900">모아PC</span>
          </Link>

          {/* Essential Links */}
          <div className="flex gap-6 text-sm text-gray-600">
            <Link to="/terms" className="hover:text-gray-900 transition-colors">
              이용약관
            </Link>
            <Link to="/privacy" className="hover:text-gray-900 transition-colors">
              개인정보처리방침
            </Link>
          </div>

          {/* Copyright */}
          <p className="text-sm text-gray-500">
            &copy; {currentYear} 모아PC. All rights reserved.
          </p>
        </div>

        {/* Affiliate Disclosure */}
        <div className="mt-4 pt-4 border-t border-gray-200">
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            <strong>어필리에이트 공지:</strong> 이 사이트는 알리익스프레스(AliExpress) 제휴 마케팅 프로그램에 참여하고 있습니다.
            제품 링크를 통해 구매 시 소정의 수수료가 지급될 수 있습니다.
            이는 사용자에게 추가 비용을 발생시키지 않으며, 사이트 운영에 도움이 됩니다.
          </p>
        </div>
      </div>
    </footer>
  );
}
